import { IFinSobCheckItem } from 'legacy/lut/components/widgets/public/partner360/planning/models/IFinSobCheckItem'

export const finSobBaseValidationRules: IFinSobCheckItem[] = [
  {
    // Check SOB Actuals Quarterly: Compare SoB Actual with prev FQ SoB Actual
    key: 'jbp-planning-check-sob-actuals-quarterly',
    order: 1,
    isEnabled: true,

    // category: '(all)' (default) | 'jbp-overall' | 'jbp-any'
    // category: 'jbp-overall',

    // value: 'fin' (default) | 'sob' | 'units'
    // type: 'actuals' | 'targets' (default)
    // fq, fy: 'curr' (default) | 'prev'
    // isSkipEmpty: false
    current: { value: 'sob', type: 'actuals' },
    compareTo: { value: 'sob', type: 'actuals', fq: 'prev' },

    // Thresholds in percent
    thresholds: { warning: 5, error: 10 },
  },
  {
    // Check SOB Actuals Quarterly: Compare SoB Actual with prev FY and same FQ SoB Actual
    key: 'jbp-planning-check-sob-actuals-quarterly',
    order: 2,
    isEnabled: true,
    current: { value: 'sob', type: 'actuals' },
    compareTo: { value: 'sob', type: 'actuals', fy: 'prev' },
    thresholds: { warning: 5, error: 10 },
  },
]
